import React, { Component } from 'react';

import TicketBox from './TicketBox';
import IconTicketHistory from '../../assets/icons/IconTicketHistory';
import IconTicketHistorySecond from '../../assets/icons/IconTicketHistorySecond';
import IconTicketUser from '../../assets/icons/IconTicketUser';
import IconTicketWifi from '../../assets/icons/IconTicketWifi';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';

class TicketBoxListAll extends Component {
    filterStatus = status => {
        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.length;
    };

    filterDataTracker = status => {
        if (status === STATUS_TICKET_CONSTANT.UNASSIGNED) {
            const filtered = this.props.data.filter((ticket) => ticket.status === status);
            return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
        }

        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        const result = [];
        const csDict = {};
        for (const item of filtered) {
            const { cs, id: ticketId, ticket_no: ticketNo, status, assignee_id } = item;
            if (!(cs in csDict)) {
                csDict[cs] = { cs, ticket_id: [], ticket_no: [], status, assignee_id };
            }
            csDict[cs].ticket_id.push(ticketId);
            csDict[cs].ticket_no.push(ticketNo);
            csDict[cs].status = status;
            csDict[cs].assignee_id = assignee_id;
        }
        for (const key in csDict) {
            result.push(csDict[key]);
        }
        result.sort((a, b) => a.cs.localeCompare(b.cs));
        return result;
    }

    render() {
        return (
            <>
                {/* Dashboard Ticket box */}
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnunassigned" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.UNASSIGNED))} titleTicket="unassigned" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.UNASSIGNED)} iconTicket={<IconTicketHistory />} textColor="text-nexcarered1" iconBoxColor="bg-nexcarered1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnassigned" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.ASSIGNED))} titleTicket="assigned" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.ASSIGNED)} iconTicket={<IconTicketUser />} textColor="text-nexcareblue2" iconBoxColor="bg-nexcareblue2" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btninprogress" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.IN_PROGRESS))} titleTicket="in progress" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.IN_PROGRESS)} iconTicket={<IconTicketHistorySecond />} textColor="text-nexcareorange1" iconBoxColor="bg-nexcareorange1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnonhold" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.ON_HOLD))} titleTicket="on hold" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.ON_HOLD)} iconTicket={<IconTicketHistorySecond />} textColor="text-nexcareblue1" iconBoxColor="bg-nexcareblue1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btncsonline" handlePopup={this.props.handlePopupCsOnline} titleTicket="total cs online" totalTicket={this.props.totalOnline.length} iconTicket={<IconTicketWifi />} textColor="text-nexcareblue2" iconBoxColor="bg-nexcareblue2" />
                </div>
            </>
        );
    }
}

export default TicketBoxListAll;